import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import logger from '../utils/logger';

export interface EmbedModeState {
  /** 埋め込みモードが有効かどうか */
  isEmbedMode: boolean;
  /** 指定されたレポートID（report-idパラメータ） */
  reportId: string | null;
  /** 指定されたレポート名（report-nameパラメータ） */
  reportName: string | null;
}

/**
 * 埋め込みモード検出フック
 *
 * URLパラメータを解析して埋め込みモードの状態を返します。
 *
 * @example
 * ```
 * // 埋め込みモード + レポートID指定
 * https://app.midas-app.org/?mds=...&report-id=report_abc123&embed=true
 *
 * // 埋め込みモード + レポート名指定
 * https://app.midas-app.org/?mds=...&report-name=my-report&embed=true
 * ```
 */
export function useEmbedMode(): EmbedModeState {
  const [searchParams] = useSearchParams();

  const state = useMemo(() => {
    const embedParam = searchParams.get('embed');
    const isEmbedMode = embedParam === 'true';
    const reportId = searchParams.get('report-id');
    const reportName = searchParams.get('report-name');

    if (isEmbedMode) {
      logger.info('[useEmbedMode] Embed mode detected', {
        reportId,
        reportName,
      });
    }

    return {
      isEmbedMode,
      reportId,
      reportName,
    };
  }, [searchParams]);

  return state;
}
